import { render, staticRenderFns } from "./WorkerFiles.vue?vue&type=template&id=0b909b8f&"
import script from "./WorkerFiles.vue?vue&type=script&lang=js&"
export * from "./WorkerFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports